import type { AccountInfo } from '@azure/msal-browser';

export type EntraUser = AccountInfo & {
  readonly availableJwtScopes: readonly string[];
};

export const loggedInUser: EntraUser = {
  homeAccountId:
    '4238711e-e28d-4a37-b76e-2144d47d6e46.41865207-6f7e-4680-87a4-3a56247738b8',
  localAccountId: '4238711e-e28d-4a37-b76e-2144d47d6e46',
  environment: 'login.microsoftonline.com',
  tenantId: '41865207-6f7e-4680-87a4-3a56247738b8',
  username: 'alice@contoso.com',
  name: 'Alice Contoso',
  availableJwtScopes: [
    'api://mock-client-id/User.Read',
    'api://mock-client-id/User.Write',
    'api://mock-client-id/MaintenanceMonitor.Read',
    'api://d8472ab8-d872-4f19-959c-11eecaee0cdc/access_as_user',
  ],
} as const;

export const loggedOutUser: EntraUser = {
  homeAccountId:
    'f1839e55-8a21-4f1b-8521-113f9f7a7525.41865207-6f7e-4680-87a4-3a56247738b8',
  localAccountId: 'f1839e55-8a21-4f1b-8521-113f9f7a7525',
  environment: 'login.microsoftonline.com',
  tenantId: '41865207-6f7e-4680-87a4-3a56247738b8',
  username: 'bob@contoso.com',
  name: 'Bob Contoso',
  availableJwtScopes: [
    'api://mock-client-id/User.Read',
    'api://mock-client-id/MaintenanceMonitor.Read',
    'api://d8472ab8-d872-4f19-959c-11eecaee0cdc/access_as_user',
  ],
} as const;

export const userWithoutScopes: EntraUser = {
  homeAccountId:
    '83234d7d-d123-424a-a12b-3168a2653242.41865207-6f7e-4680-87a4-3a56247738b8',
  localAccountId: '83234d7d-d123-424a-a12b-3168a2653242',
  environment: 'login.microsoftonline.com',
  tenantId: '41865207-6f7e-4680-87a4-3a56247738b8',
  username: 'carol@fabrikam.com',
  name: 'Carol Fabrikam',
  availableJwtScopes: [],
} as const;

export const users: EntraUser[] = [
  loggedInUser,
  loggedOutUser,
  userWithoutScopes,
];
